import imar from '../views/imar'
import ippsu from '../views/ippsu'

export const routes = [
    {
        path: '/imar',
        name: 'imar',
        component: imar
    },
    {
        path: '/ippsu',
        name: 'ippsu',
        component: ippsu
    }
]